import { jwtDecode } from 'jwt-decode';

const DEFAULT_IP = '127.0.0.1';

export const getClientIpFromGeolocationToken = (
  geolocationToken?: string | null,
): string => {
  if (!geolocationToken) {
    return DEFAULT_IP;
  }

  try {
    const parsed = jwtDecode<{ ip_address?: string }>(geolocationToken);
    if (parsed.ip_address) {
      return parsed.ip_address;
    }
  } catch {
    return DEFAULT_IP;
  }

  return DEFAULT_IP;
};
